import { DocumentNode } from 'graphql';
import { graphql } from '../gql';
import { useQuery } from '@apollo/client';

export const GET_CLAIM_VENDOR_SERVICES = graphql(`
  query GetClaimVendorServices(
    $serviceFilterInput: ServiceFilterInput
    $sort: PaginationSort
  ) {
    claimServices(filters: $serviceFilterInput, sort: $sort) {
      pageInfo {
        totalResults
      }
      edges {
        node {
          uuid
          name
          vendors {
            uuid
            selected
            aliases {
              edges {
                node {
                  uuid
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`);

export function useContactVendorsListQuery(claimUuid: string) {
  const { loading, data, error, refetch } = useQuery(
    GET_CLAIM_VENDOR_SERVICES as DocumentNode,
    {
      variables: {
        serviceFilterInput: {
          claimUuid,
        },
        sort: {
          key: 'name',
          order: 'ASC',
        },
      },
      fetchPolicy: 'no-cache',
    }
  );

  return {
    loading,
    error,
    data,
    refetch,
  };
}
